import { ofType } from "redux-observable";
import { of, EMPTY } from "rxjs";
import { mergeMap } from "rxjs/operators";
import fromAuthTypes from "features/authorisation/actions/types";
import {
	restoreQueueItems,
	sendRequested,
} from "../actions";
import {
	readOfflineSyncQueueBackup,
	clearOfflineSyncQueueBackup,
} from "../offline-queue-backup";

/**
 * After a successful login, restore any offline sync queue that was backed up
 * during logout (e.g. timesheets captured while offline with an expired token).
 */
const restoreOfflineQueueAfterLoginEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromAuthTypes.AUTHORISATION_LOGIN_FULFILLED),
		mergeMap(() => {
			const backup = readOfflineSyncQueueBackup();
			if (!backup) {
				return EMPTY;
			}

			clearOfflineSyncQueueBackup();

			const existingIds = new Set(
				(state$.value.queue?.list || [])
					.filter((i) => i && i.id)
					.map((i) => i.id)
			);
			const toRestore = backup.filter((i) => i && i.id && !existingIds.has(i.id));
			if (!toRestore.length) {
				return EMPTY;
			}

			return of(restoreQueueItems(toRestore), sendRequested());
		})
	);

export default restoreOfflineQueueAfterLoginEffect;
